<template>
  <div class="list" @click="detailsTap(item.id)">
    <div class="list-title">{{ item.goodsName }}</div>
    <div class="list-main">
      <div class="list-main-imgwrap">
        <van-image
          class="list-main-imgwrap-img"
          fit="cover"
          :src="item.goodsUrl"
        />
        <div class="list-main-imgwrap-tab" v-if="item.useCoupon == 1">券</div>
      </div>
      <div class="list-main-info">
        <div class="list-main-info-price">
          {{ item.price === null ? '' : '￥'
          }}<span>{{ item.price === null ? '面议' : item.price }}</span>
        </div>
        <div class="list-main-info-type">机构名称：{{ item.goodsOrg }}</div>
        <div class="list-main-info-type">类型：{{ item.goodsType }}</div>
      </div>
    </div>
    <div class="list-coupons">
      <div class="list-coupons-price" v-if="item.deductionPrice">
        服务券抵扣：-￥{{ item.deductionPrice }}
      </div>
      <div class="list-coupons-price" v-if="item.realPay != null">
        实付款：￥{{ item.realPay }}
      </div>
    </div>
    <div class="list-bottom">
      <div class="list-bottom-status">
        <van-image
          class="list-bottom-status-icon"
          :src="
            item.orderStatus == 3 ? img3 : item.orderStatus == 4 ? img2 : img1
          "
        />
        <div
          class="list-bottom-status-text"
          :style="{
            color:
              item.orderStatus == 3
                ? '#39CD36'
                : item.orderStatus == 4
                ? '#666666'
                : '#0080FF'
          }"
        >
          {{ item.statusText }}
        </div>
      </div>
      <div class="list-bottom-cancellation">
        <div
          v-if="item.orderStatus === 4 && item.deductionPrice"
          style="background: rgba(57, 205, 54, 0.1);border-radius: 4px;font-size:13px;padding:8px"
        >
          <span style="color:#39CD36">退款成功</span> 已退回服务券￥{{
            item.deductionPrice
          }}元
        </div>
        <van-button
          class="list-bottom-btn"
          v-if="item.orderStatus === 0 || item.orderStatus === 1"
          @click.stop="onOrderCancel(item.id)"
          >取消订单</van-button
        >
        <van-button
          class="list-bottom-btn"
          :color="item.orderStatus != 3 ? '#0080FF' : ''"
          v-if="item.orderStatus != 0 && item.orderStatus != 4"
          >{{ item.btnText }}</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { getLocalStorage, removeLocalStorage } from '@utils'
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
export default {
  props: ['item'],
  data() {
    return {
      img1: require('@/assets/sc-pic1.png'),
      img2: require('@/assets/失效状态@4x.png'),
      img3: require('@/assets/完成状态@4x.png'),
      userInfo: getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {}
    }
  },
  methods: {
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.userInfo.creditCode,
        entName: this.userInfo.entName,
        mobile: this.userInfo.mobile
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => {})
      newSaveUVRecord(params).then(res => {})
    },
    detailsTap(id) {
      removeLocalStorage('coupons')
      this.buriedPoint()
      this.$router.push({
        path: '/market/orderDetails',
        query: {
          id: id
        }
      })
    },
    // 取消订单
    onOrderCancel(id) {
      this.$router.push({
        path: '/market/orderCancel?id=' + id
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.list {
  background: #fff;
  margin-top: 15px;
  border-radius: 4px;
  &-title {
    font-size: 16px;
    padding: 10px 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-bottom: 1px solid #eee;
  }
  &-main {
    padding: 10px 15px;
    display: flex;
    align-items: center;
    &-imgwrap {
      position: relative;
      &-img {
        width: 90px;
        height: 80px;
      }
      &-tab {
        padding: 6px;
        background: #ff5c2c;
        font-size: 12px;
        color: #fff;
        position: absolute;
        top: 0;
        left: 0;
        border-bottom-right-radius: 10px;
      }
    }
    &-info {
      flex: 1;
      padding-left: 10px;
      overflow: hidden;
      &-price {
        font-size: 14px;
        color: #999;
        span {
          font-size: 18px;
          font-weight: bold;
          color: #333333;
        }
      }
      &-type {
        font-size: 14px;
        color: #999;
        margin-top: 6px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  &-coupons {
    display: flex;
    align-items: center;
    padding: 0 15px 10px;
    &-price {
      font-size: 12px;
      color: #666;
      margin-right: 10px;
    }
  }
  &-bottom {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    padding: 0 15px 15px;
    &-status {
      height: 36px;
      flex: 1;
      display: flex;
      align-items: center;
      padding: 0 15px;
      border-radius: 6px;
      &-icon {
        width: 16px;
        // height: 16px;
      }
      &-text {
        font-size: 14px;
        padding-left: 5px;
      }
    }
    &-btn {
      width: 90px;
      padding: 0 10px;
      height: 36px;
      border-radius: 6px;
      margin-left: 18px;
    }
    &-cancellation {
      height: 36px;
      display: flex;
      align-items: center;
      // border
      text-align: right;
    }
  }
}
</style>
